import { ButtonV2, TextLink } from '@moneyforward/ap-frontend-components';

import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';

import { ExportButton } from '@/features/transaction_items/Detail/components/ButtonGroup/ExportButton/ExportButton';
import {
  ExportCustomTransactionItemOptionsBodyCsvEncoding,
  GetImportExportHistoriesListSource,
} from 'ap-openapi';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './TransactionDetailOptionButtonGroup.module.scss';

export type Props = {
  onAdd: () => void;
  onImport: () => void;
  onExport: (
    csv_encoding: ExportCustomTransactionItemOptionsBodyCsvEncoding
  ) => void;
  isDisabled: boolean;
  isSupportedOffice: boolean;
  isEmptyTable: boolean;
};

const cx = classNames.bind(styles);

export const TransactionDetailOptionButtonGroup: FC<Props> = memo(
  ({
    onAdd,
    onImport,
    onExport,
    isDisabled,
    isSupportedOffice,
    isEmptyTable,
  }: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const handleImportExportHistoryClick = () => {
      navigate(
        {
          pathname: '/import_export_histories',
          search: `?source=${GetImportExportHistoriesListSource.custom_transaction_item_options}`,
        },
        { state: { from: location.pathname } }
      );
    };

    return (
      <div className={cx(styles['button-group'])}>
        <TextLink
          className={cx(styles['link-button'])}
          href={undefined}
          onClick={handleImportExportHistoryClick}
        >
          {t('import_export_history_link_text')}
        </TextLink>
        {isSupportedOffice && (
          <div className={cx(styles.actions)}>
            <ExportButton
              isDisabled={isDisabled || isEmptyTable}
              onExport={onExport}
            />
            <ButtonV2 isTertiary onClick={onImport} isDisabled={isDisabled}>
              {t('import')}
            </ButtonV2>
            <ButtonV2 onClick={onAdd} isDisabled={isDisabled}>
              {t('add')}
            </ButtonV2>
          </div>
        )}
      </div>
    );
  }
);
TransactionDetailOptionButtonGroup.displayName =
  'TransactionDetailOptionButtonGroup';
